/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenderAndSterilizationV2Model
 */
export interface GenderAndSterilizationV2Model {
    /**
     * 
     * @type {string}
     * @memberof GenderAndSterilizationV2Model
     */
    gender: GenderAndSterilizationV2ModelGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenderAndSterilizationV2Model
     */
    sterilization: boolean;
    /**
     * 
     * @type {string}
     * @memberof GenderAndSterilizationV2Model
     */
    name: string;
}


/**
 * @export
 */
export const GenderAndSterilizationV2ModelGenderEnum = {
    Unknown: 'UNKNOWN',
    Male: 'MALE',
    Female: 'FEMALE'
} as const;
export type GenderAndSterilizationV2ModelGenderEnum = typeof GenderAndSterilizationV2ModelGenderEnum[keyof typeof GenderAndSterilizationV2ModelGenderEnum];


/**
 * Check if a given object implements the GenderAndSterilizationV2Model interface.
 */
export function instanceOfGenderAndSterilizationV2Model(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "sterilization" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GenderAndSterilizationV2ModelFromJSON(json: any): GenderAndSterilizationV2Model {
    return GenderAndSterilizationV2ModelFromJSONTyped(json, false);
}

export function GenderAndSterilizationV2ModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenderAndSterilizationV2Model {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gender': json['gender'],
        'sterilization': json['sterilization'],
        'name': json['name'],
    };
}

export function GenderAndSterilizationV2ModelToJSON(value?: GenderAndSterilizationV2Model | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gender': value.gender,
        'sterilization': value.sterilization,
        'name': value.name,
    };
}

